import { render, staticRenderFns } from "./PainelContinuidade.vue?vue&type=template&id=3cd54cbb"
import script from "./PainelContinuidade.vue?vue&type=script&lang=js"
export * from "./PainelContinuidade.vue?vue&type=script&lang=js"
import style0 from "./PainelContinuidade.vue?vue&type=style&index=0&id=3cd54cbb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports